<template>
  <div class="d-flex flex-column" style="height:100vh;">
    <!-- TODO: apply any markup that is common to all private views and not shared with the public views Private View -->
      <appHeader></appHeader>
      <b-container class="wrapper">
        <router-view></router-view>
      </b-container>
    <appFooter class="d-none d-sm-flex bottom-footer mt-auto"></appFooter>
  </div>

</template>

<script>
import appHeader from './shared/components/header'
import appFooter from './shared/components/footer'

export default {
  components: { appHeader, appFooter }
}
</script>
